import React from 'react'
import PropTypes, { array, string } from 'prop-types'

import { Button } from 'Components/UI/_Legacy'

import { DEMO_LINK } from 'Constants/Common'
import { DATA_LAYERS } from 'Constants/DataLayers'

import { addDataLayer } from 'Services/gtm.js'

import ButtonIcon from './styles'

const WantToSeeDemoButton = ({ width }) => (
  <Button.Link
    blueprint
    href={DEMO_LINK}
    target="_blank"
    width={width}
    onClick={() => addDataLayer(DATA_LAYERS.blueprint.watchDemo)}
  >
    I want to see the demo
    <ButtonIcon />
  </Button.Link>
)

WantToSeeDemoButton.propTypes = {
  width: PropTypes.oneOfType([string, array]).isRequired,
}

export default WantToSeeDemoButton
